import { Swiper, Navigation, Pagination, Thumbs, Autoplay } from "swiper/dist/js/swiper.esm.js";

Swiper.use([Navigation, Pagination, Thumbs, Autoplay]);

export default () => {
    // Instâncias do Swiper aqui...
    var swiper = new Swiper('.home-main-banner', {
        autoplay: {
            delay: 5000,
        },
        pagination: {
          el: '.swiper-pagination',
        },
    });

    var swiper = new Swiper('.navigate-modal__slider', {
        navigation: {
            nextEl: '.navigate-next',
            prevEl: '.navigate-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'fraction',
        },
    });

    var swiper = new Swiper('.products-slider-container01', {
        slidesPerView: 4,
        spaceBetween: 30,
        navigation: {
          nextEl: '.product-slide01-next',
          prevEl: '.product-slide01-prev',
        },
        // Responsive breakpoints
        breakpoints: {
            // when window width is >= 320px
            1199: {
            slidesPerView: 1,
            spaceBetween: 20
            },
        }
    });

    var swiper = new Swiper('.products-slider-container02', {
        slidesPerView: 4,
        spaceBetween: 30,
        navigation: {
            nextEl: '.product-slide02-next',
            prevEl: '.product-slide02-prev',
        },
        // Responsive breakpoints
        breakpoints: {
            // when window width is >= 320px
            1199: {
            slidesPerView: 1,
            spaceBetween: 20
            },
        }
    });

    var swiper = new Swiper('.products-slider-container03', {
        slidesPerView: 4,
        spaceBetween: 30,
        navigation: {
            nextEl: '.product-slide03-next',
            prevEl: '.product-slide03-prev',
        },
        // Responsive breakpoints
        breakpoints: {
            // when window width is >= 320px
            1199: {
            slidesPerView: 1,
            spaceBetween: 20
            },
        }
    });

    var galleryThumbs = new Swiper('.gallery-thumbs', {
        spaceBetween: 10,
        slidesPerView: 5,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        freeMode: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
    var galleryTop = new Swiper('.gallery-top', {
        spaceBetween: 10,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        thumbs: {
            swiper: galleryThumbs
        }
    });

    let yearsSlide = new Swiper(".years-slider", {
        watchOverflow: true,
        spaceBetween: 10,
        slidesPerView: 4,
        navigation: {
            nextEl: '.years-button-next',
            prevEl: '.years-button-prev',
        },
        pagination: {
            el: '.years-pagination',
            type: 'bullets',
            clickable: true,
        },
        breakpoints: {
            1199: {
                slidesPerView: 1,
            },
        },
    });

    let araripePhotos = new Swiper(".photos__slide", {
        navigation: {
            nextEl: ".photos-next",
            prevEl: ".photos-prev",
        },
    });
};
